import { render, staticRenderFns } from "./PerformanceQueryView.vue?vue&type=template&id=112fc127&scoped=true"
import script from "./PerformanceQueryView.vue?vue&type=script&lang=js"
export * from "./PerformanceQueryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112fc127",
  null
  
)

export default component.exports